import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const NotFoundPage = () => {
  return (
    <section className="bg-white" data-testid="not-found-page-root">
      <div className="mx-auto flex min-h-[60vh] w-full max-w-3xl flex-col items-center justify-center px-4 text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.12em] text-orange-600" data-testid="not-found-eyebrow">
          404
        </p>
        <h1 className="mt-3 text-4xl font-semibold text-slate-900" data-testid="not-found-title">
          Page not found
        </h1>
        <p className="mt-3 text-base text-slate-600" data-testid="not-found-description">
          The page you requested is unavailable. Return to the homepage.
        </p>
        <Button
          asChild
          className="mt-6 rounded-full bg-orange-500 px-6 py-5 text-sm font-semibold text-white hover:bg-orange-600"
          data-testid="not-found-home-button"
        >
          <Link to="/" data-testid="not-found-home-link">
            Go to Home
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default NotFoundPage;